var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/entry"}},[_vm._v("Entry")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }